import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Text,
} from "@chakra-ui/react";
import React from "react";
import VisionBox from "./VisionBox";
import Leasing from "../img/leasing.png";
import Ownership from "../img/ownership.png";
import Operations from "../img/operations.png";
import Developement from "../img/developement.png";

const Vision = () => {
  return (
    <Box py={16} bgColor={"rgb(112 208 236 / 10%)"}>
      <Container maxW={"85%"} pb={12}>
        <Grid
          gridTemplateColumns={{ xl: "repeat(5, 1fr)", lg: "repeat(6, 1fr)" }}
          gap={{ xl: 8, lg: 0 }}
          alignItems={"center"}
        >
          <GridItem
            mb={{ xl: 0, base: 8 }}
            colSpan={{ xl: 2, base: 3 }}
            textAlign={{ base: "center", lg: "left" }}
          >
            <Heading color={"DarkBlue"} fontSize={{ md: "6xl", base: "4xl" }}>
              Your Vision,
            </Heading>
            <Heading color={"DarkBlue"} fontSize={{ md: "6xl", base: "4xl" }}>
              {" "}
              Our Space
            </Heading>
          </GridItem>
          <GridItem colSpan={{ xl: 3, lg: 3 }}>
            <Text color={"DarkBlue"}>
              We take pride in cultivating trusted relationships with the
              leading health systems, hospitals, practices, and providers across
              the country. Since healthcare real estate is all we do, we remain
              persistent, passionate, and more creative than ever before to
              ensure that we exceed the expectations of our partners to meet the
              growing demand of outpatient care.
            </Text>
          </GridItem>
        </Grid>
      </Container>
      <Container maxW={{lg:"95%",md: "85%",base: "78%"}}>
        <Grid
          gridTemplateColumns={{
            xl: "repeat(4, 1fr)",
            md: "repeat(2, 1fr)",
            base: "repeat(1, 1fr)",
          }}
          gap={{lg:24,md:44, base:24}}
          alignItems={"center"}
        >
          <VisionBox
            visionImg={Ownership}
            desc={
              "Welltower is your long-term partner and owner of outpatient medical buildings."
            }
            visionLink={"/what-we-do#ownership"}
            title={"OWNERSHIP"}
          />
          <VisionBox
            visionImg={Leasing}
            desc={
              "When you access our expert team, you gain an advantage in the marketplace."
            }
            visionLink={"/what-we-do#leasing"}
            title={"LEASING"}
          />
          <VisionBox
            visionImg={Operations}
            visionLink={"/what-we-do#operation"}
            desc={"Leverage our expertise with an experienced, local team."}
            title={"OPERATIONS"}
          />
          <VisionBox
            visionImg={Developement}
            visionLink={"/what-we-do#development"}
            desc={
              "Partner with a data-driven real estate innovator who understands healthcare."
            }
            title={"DEVELOPMENT"}
          />
        </Grid>
      </Container>
    </Box>
  );
};

export default Vision;
